import React from 'react';
import { Users } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function CommunitySection() {
  return <section id="community" className="py-24 bg-rhino-black relative overflow-hidden" data-id="element-48">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-49">
        <img src="https://cdn.magicpatterns.com/uploads/nURoUX5maPgoqaf5qbZnQX/1000175394.jpg" alt="" className="w-full h-full object-cover" data-id="element-50" />
      </div>
      <div className="absolute inset-0 bg-rhino-black/80" data-id="element-51"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-52">
        <div className="max-w-3xl mx-auto text-center" data-id="element-53">
          <FadeIn data-id="element-54">
            <div className="w-20 h-20 bg-rhino-charcoal rounded-full flex items-center justify-center mx-auto mb-8 border-2 border-rhino-gold/30" data-id="element-55">
              <Users className="w-10 h-10 text-rhino-gold" data-id="element-56" />
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-57">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide mb-6" data-id="element-58">
              JOIN THE RHINO CRASH
            </h2>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-59">
            <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-60">
              A group of rhinos is called a crash. Join our global community for
              inspiration, encouragement, accountability, and strength. We
              charge together.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-61">
            <div className="bg-rhino-charcoal/80 backdrop-blur-sm p-6 rounded-sm border border-rhino-grey inline-block mb-10" data-id="element-62">
              <p className="text-rhino-gold italic font-serif text-lg" data-id="element-63">
                "And let us consider how we may spur one another on toward love
                and good deeds, not giving up meeting together... but
                encouraging one another."
              </p>
              <p className="text-sm text-gray-500 mt-3 font-medium" data-id="element-64">
                — Hebrews 10:24-25
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-65">
            <motion.a href="https://facebook.com/Rhinoman60" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center gap-3 px-8 py-4 bg-[#1877F2] text-white font-heading font-bold text-lg tracking-wider uppercase rounded hover:bg-[#166FE5] transition-all shadow-lg shadow-blue-900/20" data-id="element-66">
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" data-id="element-67">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-68" />
              </svg>
              Join the Facebook Group
            </motion.a>
          </FadeIn>
        </div>
      </div>
    </section>;
}